import React, { useLayoutEffect, useState } from "react";
import {
  AXIOS_GET,
  AXIOS_POST,
  AXIOS_UPDATE,
} from "../../../../server/api/crud";
import Swal from "sweetalert2";
import { emailVoedingHTML } from "../../../../EmailTemplates";
import { sendEmail } from "../../../../function";

const GenerateButtons = ({ data, name, handleMetricChange, disabled }) => {
  return (
    <div className="flex flex-wrap gap-1.5 sm:gap-2">
      {Array.from({ length: 11 }, (_, index) => {
        const selected = data === index;
        return (
          <button
            key={index}
            type="button"
            disabled={disabled}
            onClick={() => !disabled && handleMetricChange(index, name)}
            className={`min-h-[2.5rem] min-w-[2.25rem] rounded-lg border px-2.5 py-2 text-sm font-semibold transition sm:min-w-[2.5rem] sm:px-3 ${
              selected
                ? "border-wa-accent bg-wa-accent text-wa-onaccent shadow-sm"
                : "border-wa-border bg-wa-panel2/50 text-wa-text hover:bg-wa-hover disabled:cursor-not-allowed disabled:opacity-50"
            }`}
          >
            {index}
          </button>
        );
      })}
    </div>
  );
};

const fieldClass =
  "mt-1 block w-full rounded-xl border border-wa-border bg-wa-panel2/50 px-3 py-2.5 text-sm text-wa-text ring-1 ring-inset ring-wa-border/50 focus:border-wa-accent focus:outline-none focus:ring-2 focus:ring-wa-accent/35 disabled:cursor-not-allowed disabled:opacity-60 dark:bg-wa-panel/40";

const labelClass = "block text-sm font-semibold text-wa-text sm:text-base";

const radioGroupClass =
  "mt-3 flex flex-col gap-2 sm:flex-row sm:flex-wrap sm:gap-3";

const radioItemClass =
  "flex cursor-pointer items-start gap-2 rounded-xl border border-wa-border bg-wa-panel2/40 p-3 text-sm text-wa-text transition hover:bg-wa-hover/80 dark:bg-wa-panel/30 sm:items-center sm:px-3 sm:py-2";

const DagelijksFormulier = ({
  setSelected,
  setOpen,
  admin = null,
  voeding,
  userdetails,
}) => {
  const [formData, setFormData] = useState({
    kookfrequentie: "",
    uit_eten_frequentie: "",
    winkel_frequentie: "",
    kookvaardigheid: 5,
    plezier_in_koken: "",
    plezier_in_koken_text: "",
    voeding_id: voeding?.id,
    definitief: 0,
    user_id: userdetails?.user_id,
    admin_opm: "",
  });
  const [isSaving, setIsSaving] = useState(false);

  const disabled = admin != null;

  const handleMetricChange = (data, name) => {
    setFormData({ ...formData, [name]: data });
  };

  const getData = async () => {
    try {
      const res = await AXIOS_GET(
        `voedsel/dagelijksegewoonten/user/${userdetails?.user_id}`
      );
      if (res.status === 200 && res.data?.data?.length > 0) {
        setFormData(res.data.data[0]);
      }
    } catch (e) {
      console.error("dagelijksegewoonten fetch:", e);
    }
  };

  useLayoutEffect(() => {
    getData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const saveForm = async () => {
    const id = formData?.id;
    const newObject = { ...formData, definitief: 1 };
    const respons = id
      ? await AXIOS_UPDATE(`voedsel/dagelijksegewoonten`, id, newObject)
      : await AXIOS_POST(`voedsel/dagelijksegewoonten`, newObject);
    if (respons.status === 200) {
      Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Bedankt voor het invullen van dit formulier",
        showConfirmButton: false,
        timer: 2500,
      });
      try {
        const statusRes = await AXIOS_UPDATE(`voedsel/status`, voeding?.id, {
          status: 3,
        });
        if (statusRes.status === 200) {
          const verstuurRes = await AXIOS_UPDATE(
            `voedsel/versturen`,
            voeding?.id,
            { versturen: 1 }
          );
          if (verstuurRes.status === 200) {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Voedingsformulier verstuurd",
              showConfirmButton: false,
              timer: 2500,
            });

            const emailData = {
              from_name: "RepeatConnect Preintake Verzonden",
              sender_email: "info@repeathealth.com",
              title: `Hallo ${userdetails?.first_name}, Uw ingevulde voedingsdagboek is succesvol verzonden.`,
              receiver_email: userdetails?.email,
              gebruikersnaam: userdetails?.email,
              name: userdetails?.full_name,
              inloglink: "https://repeatconnect.com",
            };

            const emailHtml = emailVoedingHTML(emailData);
            sendEmail("template_qdoh9mv", {
              message_html: emailHtml,
              title: emailData?.title,
              receiver_email: emailData?.receiver_email,
            });

            setOpen(false);
          }
        }
      } catch (error) {
        console.error("versturen voeding:", error);
      }
    }
  };

  const opslaanOpmerking = async () => {
    const id = formData?.id;
    const newObject = { ...formData, admin_id: admin?.id };
    const reponseAdmin = await AXIOS_UPDATE(
      `voedsel/dagelijksegewoonten/admin`,
      id,
      newObject
    );
    if (reponseAdmin.status === 200) {
      Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Uw opmerking werd geplaatst",
        showConfirmButton: false,
        timer: 2500,
      });

      setOpen(false);
    }
  };

  const saveForLaterForm = async () => {
    const id = formData?.id;
    const payload = { ...formData, definitief: 0 };
    const respons = id
      ? await AXIOS_UPDATE(`voedsel/dagelijksegewoonten`, id, payload)
      : await AXIOS_POST(`voedsel/dagelijksegewoonten`, payload);
    if (respons.status === 200) {
      Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Opgeslagen. U kunt later verder gaan.",
        showConfirmButton: false,
        timer: 2500,
      });

      setOpen(false);
    }
  };

  const verzendenForm = async (e) => {
    e.preventDefault();
    if (isSaving) return;
    try {
      setIsSaving(true);
      await saveForm();
    } finally {
      setIsSaving(false);
    }
  };

  const opslaanLaterVerderdoen = async (e) => {
    e.preventDefault();
    if (isSaving) return;
    try {
      setIsSaving(true);
      await saveForLaterForm();
    } finally {
      setIsSaving(false);
    }
  };

  const handleAdminSave = async (e) => {
    e.preventDefault();
    if (isSaving) return;
    try {
      setIsSaving(true);
      await opslaanOpmerking();
    } finally {
      setIsSaving(false);
    }
  };

  const kookOpties = [
    "0 maaltijden",
    "1-2 maaltijden",
    "3-4 maaltijden",
    "5 of meer",
  ];

  const winkelOpties = [
    "Dagelijks meerdere keren",
    "Dagelijks",
    "Om de 2 dagen",
    "Paar dagen per week",
    "1 keer per week",
    "Minder dan 1 keer per week",
    "Ik doe geen inkopen",
  ];

  return (
    <div className="rounded-2xl border border-wa-border/80 bg-wa-panel/20 p-4 shadow-sm ring-1 ring-black/[0.02] dark:bg-wa-panel2/15 dark:ring-white/[0.04] sm:p-6 lg:p-8">
      <div className="rounded-xl border border-wa-border/60 bg-wa-panel2/35 px-4 py-3 text-center text-sm font-medium text-wa-text sm:text-left dark:bg-wa-panel/30">
        Stap 3 — Dagelijkse gewoonten: koken, inkopen en plezier in de keuken.
      </div>

      <form className="mx-0 my-6 max-w-4xl space-y-8 sm:mx-auto sm:my-8 lg:my-10">
        <div>
          <span className={labelClass}>
            Hoe vaak kook je per week?
          </span>
          <div className={radioGroupClass}>
            {kookOpties.map((option) => (
              <label key={option} className={radioItemClass}>
                <input
                  type="radio"
                  name="kookfrequentie"
                  disabled={disabled}
                  value={option}
                  checked={formData?.kookfrequentie === option}
                  onChange={handleChange}
                  className="mt-0.5 h-4 w-4 shrink-0 border-wa-border text-wa-accent focus:ring-wa-accent sm:mt-0"
                />
                <span>{option}</span>
              </label>
            ))}
          </div>
        </div>

        <div>
          <span className={labelClass}>
            Hoe vaak per week ga je uit eten of maak je gebruik van
            afhaalmaaltijden of maaltijdleveringen?
          </span>
          <div className={radioGroupClass}>
            {kookOpties.map((option) => (
              <label key={option} className={radioItemClass}>
                <input
                  type="radio"
                  name="uit_eten_frequentie"
                  disabled={disabled}
                  value={option}
                  checked={formData?.uit_eten_frequentie === option}
                  onChange={handleChange}
                  className="mt-0.5 h-4 w-4 shrink-0 border-wa-border text-wa-accent focus:ring-wa-accent sm:mt-0"
                />
                <span>{option}</span>
              </label>
            ))}
          </div>
        </div>

        <div>
          <span className={labelClass}>Hoe vaak doe jij inkopen?</span>
          <div className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-3">
            {winkelOpties.map((option) => (
              <label key={option} className={radioItemClass}>
                <input
                  type="radio"
                  name="winkel_frequentie"
                  value={option}
                  disabled={disabled}
                  checked={formData?.winkel_frequentie === option}
                  onChange={handleChange}
                  className="mt-0.5 h-4 w-4 shrink-0 border-wa-border text-wa-accent focus:ring-wa-accent sm:mt-0"
                />
                <span className="leading-snug">{option}</span>
              </label>
            ))}
          </div>
        </div>

        <div>
          <span className={labelClass}>
            Geef jouw keukenvaardigheden een score (0–10)
          </span>
          <div className="mt-3">
            <GenerateButtons
              data={formData?.kookvaardigheid}
              disabled={disabled}
              name="kookvaardigheid"
              handleMetricChange={handleMetricChange}
            />
          </div>
          <p className="mt-2 text-center text-sm text-wa-muted sm:text-left">
            Huidige score:{" "}
            <span className="font-semibold text-wa-accent">
              {formData?.kookvaardigheid}
            </span>
          </p>
        </div>

        <div>
          <span className={labelClass}>Kook je graag?</span>
          <div className={radioGroupClass}>
            {["Ja", "Soms", "Neen"].map((option) => (
              <label key={option} className={radioItemClass}>
                <input
                  type="radio"
                  name="plezier_in_koken"
                  disabled={disabled}
                  value={option}
                  checked={formData?.plezier_in_koken === option}
                  onChange={handleChange}
                  className="mt-0.5 h-4 w-4 shrink-0 border-wa-border text-wa-accent focus:ring-wa-accent sm:mt-0"
                />
                <span>{option}</span>
              </label>
            ))}
          </div>
          <label className={`${labelClass} mt-4`} htmlFor="plezier_in_koken_text">
            Toelichting (optioneel)
          </label>
          <textarea
            id="plezier_in_koken_text"
            name="plezier_in_koken_text"
            value={formData?.plezier_in_koken_text}
            disabled={disabled}
            onChange={handleChange}
            rows={5}
            className={`${fieldClass} resize-y`}
            placeholder="Beschrijf kort…"
          />
          {admin != null && (
            <div className="mt-6">
              <label className={labelClass} htmlFor="admin_opm">
                Opmerking specialist
              </label>
              <textarea
                name="admin_opm"
                id="admin_opm"
                value={formData?.admin_opm}
                onChange={handleChange}
                rows={6}
                className={`${fieldClass} resize-y`}
                placeholder="Geef feedback…"
              />
            </div>
          )}
        </div>

        <div className="flex flex-col gap-3 border-t border-wa-border/70 pt-6 sm:flex-row sm:flex-wrap sm:items-stretch sm:justify-between">
          <div className="flex flex-col gap-2 sm:flex-row sm:flex-wrap sm:gap-2">
            <button
              type="button"
              onClick={() => setOpen(false)}
              disabled={isSaving}
              className="inline-flex w-full items-center justify-center rounded-xl border border-wa-border bg-wa-panel2/60 px-4 py-3 text-sm font-semibold text-wa-text shadow-sm transition hover:bg-wa-hover disabled:opacity-50 sm:w-auto"
            >
              Annuleren
            </button>
            <button
              type="button"
              onClick={() => !isSaving && setSelected(1)}
              disabled={isSaving}
              className="inline-flex w-full items-center justify-center rounded-xl border border-wa-border bg-wa-panel2/40 px-4 py-3 text-sm font-semibold text-wa-text transition hover:bg-wa-hover disabled:opacity-50 sm:w-auto"
            >
              Vorige
            </button>
          </div>

          {admin == null ? (
            <div className="flex flex-col gap-2 sm:flex-row sm:justify-end">
              <button
                type="button"
                onClick={opslaanLaterVerderdoen}
                disabled={isSaving}
                className="inline-flex w-full items-center justify-center rounded-xl border border-wa-accent/40 bg-wa-accent/10 px-4 py-3 text-sm font-semibold text-wa-accent transition hover:bg-wa-accent/15 disabled:opacity-50 sm:w-auto"
              >
                {isSaving ? "Bezig…" : "Opslaan en later verder"}
              </button>
              <button
                type="button"
                onClick={verzendenForm}
                disabled={isSaving}
                className="inline-flex w-full items-center justify-center rounded-xl bg-wa-accent px-5 py-3 text-sm font-semibold text-wa-onaccent shadow-md transition hover:bg-wa-accentdeep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-wa-accent disabled:opacity-60 sm:w-auto sm:min-w-[10rem]"
              >
                {isSaving ? "Bezig…" : "Verzenden"}
              </button>
            </div>
          ) : (
            <button
              type="button"
              onClick={handleAdminSave}
              disabled={isSaving}
              className="inline-flex w-full items-center justify-center rounded-xl bg-wa-accent px-5 py-3 text-sm font-semibold text-wa-onaccent shadow-md transition hover:bg-wa-accentdeep disabled:opacity-60 sm:ml-auto sm:w-auto sm:min-w-[12rem]"
            >
              {isSaving ? "Bezig…" : "Opmerking opslaan"}
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default DagelijksFormulier;
